var map = {
	"./404.svg": 3530,
	"./bug.svg": 7130,
	"./chart.svg": 8545,
	"./clipboard.svg": 6637,
	"./component.svg": 2406,
	"./dashboard.svg": 8749,
	"./documentation.svg": 9607,
	"./drag.svg": 224,
	"./edit.svg": 8352,
	"./education.svg": 3085,
	"./email.svg": 1533,
	"./example.svg": 9892,
	"./excel.svg": 9139,
	"./exit-fullscreen.svg": 871,
	"./eye-open.svg": 4301,
	"./eye.svg": 4986,
	"./form.svg": 4062,
	"./fullscreen.svg": 6286,
	"./guide.svg": 5860,
	"./icon.svg": 9789,
	"./international.svg": 3906,
	"./language.svg": 9424,
	"./link.svg": 4121,
	"./list.svg": 2672,
	"./lock.svg": 9724,
	"./message.svg": 860,
	"./money.svg": 1116,
	"./nested.svg": 1476,
	"./password.svg": 6408,
	"./pdf.svg": 6500,
	"./people.svg": 2011,
	"./peoples.svg": 5765,
	"./qq.svg": 6869,
	"./search.svg": 2042,
	"./shopping.svg": 8764,
	"./size.svg": 985,
	"./skill.svg": 8673,
	"./star.svg": 8019,
	"./tab.svg": 817,
	"./table.svg": 3797,
	"./theme.svg": 987,
	"./tree-table.svg": 8509,
	"./tree.svg": 964,
	"./user.svg": 42,
	"./wechat.svg": 267,
	"./zip.svg": 7276
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7886;